import { createFileRoute } from '@tanstack/react-router';
import Referrals from 'src/pages/Organization/Players/Referrals';

export const Route = createFileRoute(
  '/$organizationSlug/players/$playerId/referrals',
)({
  component: Referrals,
});
